import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main';

export const EmailBatches = () => (
  <>
    <DocumentHead title='Email Batches' />
    <PageTemplate main={<Main />} />
  </>
);
